import React from 'react';
import User from 'components/Tvendo/Setting/Print/List';

export default function () {
  return <User />;
}
